import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Options } from '@angular-slider/ngx-slider';
import { ReservaService } from 'src/app/services';

@Component({selector: 'reserva-termometro',
  templateUrl: './reserva-termometro.component.html',
  styleUrls: ['./reserva-termometro.component.scss'], standalone: false})
export class ReservaTermometroComponent implements OnInit {
  @Input() reserva: any;
  @Output() alterou = new EventEmitter<any>();

  value: number = 0;
  comissao: number = 0;
  buscandoTermometro = true;
  Ciente = false;
  percentualMax: any;
  comissoes: any;
  toggleComissoes = true;
  // public MASKS = MASKS;

  options: Options = {

    // tickStep: 5,
    floor: -999,
    ceil: 999,
    step: 0.01,
    showSelectionBar: true,
    getSelectionBarColor: (value: number): string => {
      if (value >= (this.comissao * (25 / 100)) && value < this.comissao) {
        return 'yellow';
      }
      if (value >= 0 && value <= (this.comissao * (25 / 100))) {
        return '#2AE02A';
      }
      if (value >= this.comissao && value < this.options.ceil) {
        return 'orange';
      }
      return 'red';
    },
    translate: (value: number): string => {
      return value + ` (${((100 * value) / this.reserva.ValorTotalComissao).toFixed(2)}%)`
    },
    vertical: true
  };

  constructor(
    private modalService: NgbModal,
    private reservaService: ReservaService
  ) {}

  ngOnInit(): void {
    this.buscaTermometro(this.reserva.Id);
  }

  buscaTermometro(id) {
    this.reservaService.buscaTermometro(id).subscribe(
      dados => {
        this.options.floor = 0 - dados.floor;
        this.options.ceil = dados.ceil;
        this.comissao = Number(dados.value.toFixed(2));
        this.value = dados.value
        this.buscandoTermometro = false;
        this.comissoes = dados.Comissoes;
        if (this.reserva.ValorDescontoComissao && this.reserva.ValorDescontoComissao != 0) {
          this.value = this.comissao + this.reserva.ValorDescontoComissao;
        }
        else if (this.reserva.ValorOver && this.reserva.ValorOver != 0) {
          this.value = this.comissao + this.reserva.ValorOver;
        }

        this.value = Number(this.value.toFixed(2));
      },
      erro => {
        console.log(erro);
      }
    )
  }

  alterar() {

    // if (this.value != 0) {

    if (this.value > this.comissao) {
      this.reserva.ValorDescontoComissao = 0;
      this.reserva.ValorOver = this.value - this.comissao;
    }
    else if (this.value < this.comissao) {
      this.reserva.ValorOver = 0;
      this.reserva.ValorDescontoComissao = this.value - this.comissao;
    }
    else if (this.value == this.comissao) {
      this.reserva.ValorOver = 0;
      this.reserva.ValorDescontoComissao = 0;
    }

    this.reserva.CienteAlteracaoComissao = true;

    this.reservaService.alterarOrcamento(this.reserva).subscribe(
      dados => {
        alert("Orçamento alterado com sucesso!");
        this.alterou.emit();
      },
      erro => {
        alert("Ocorreu um erro ao atualizar o orçamento!");
      }
    )
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

}
